import { isWhatsAppComplete } from '@chatwoot/utils';
import { buildTemplateParameters } from 'dashboard/helper/templateHelper';

export const buildReminderTemplateParameters = (template, serialized = '') => {
  const parameters = buildTemplateParameters(template);
  const saved = JSON.parse(serialized || '{}');
  ['body', 'header'].forEach(section => {
    if (parameters[section]) {
      parameters[section] = { ...parameters[section], ...saved[section] };
    }
  });
  if (parameters.buttons) {
    parameters.buttons = parameters.buttons.map((button, index) =>
      button ? { ...button, ...saved.buttons?.[index] } : button
    );
  }
  return parameters;
};

export const isReminderTemplateComplete = (template, serialized) => {
  if (!template) return false;
  try {
    const parameters = buildReminderTemplateParameters(template, serialized);
    return (
      isWhatsAppComplete(template, parameters) &&
      (parameters.buttons || []).every(
        button => !button || button.parameter?.trim()
      )
    );
  } catch {
    return false;
  }
};
